import { Button, Typography } from '@breetometer/components';
import { FirstBeneficiaryIcon, PlusIcon } from 'BreetAssets';

import type { INoBeneficiary } from '../AddBeneficiary.helpers';

const NoBeneficiary = ({ intent, addAccount, header = false }: INoBeneficiary) => (
	<div
		className='payment-request-form_nobeneficiary bg-primary-400 border-dark-navy'
		data-testid='no-beneficiary'
	>
		<FirstBeneficiaryIcon className='svg-dark svg-dark-outline svg-dark-fill' />
		{header && (
			<Typography
				as='h3'
				className='color-neutral-50'
			>
				Add a Bank Account
			</Typography>
		)}
		<Typography className='color-primary-50'>You need to have a saved beneficiary to {intent}.</Typography>
		<Button
			label='Add Account'
			type='button'
			variant='tertiary'
			className='theme-background-none'
			leadingIcon={<PlusIcon className='plusicon' />}
			onClick={addAccount}
		/>
	</div>
);

export default NoBeneficiary;
